module.exports = __webpack_public_path__ + "img/logoWhite.b935fe71.svg";